import { render, staticRenderFns } from "./assessDetails.vue?vue&type=template&id=71872e63&scoped=true"
import script from "./assessDetails.vue?vue&type=script&lang=js"
export * from "./assessDetails.vue?vue&type=script&lang=js"
import style0 from "./assessDetails.vue?vue&type=style&index=0&id=71872e63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71872e63",
  null
  
)

export default component.exports